/**
 * Phase 4f.C — Shop-Checkout abgebrochen.
 * Stripe leitet hierher zurück, wenn der Käufer "Abbrechen" klickt.
 * Der Warenkorb bleibt unberührt — Käufer kann erneut bezahlen.
 */
import { Link } from "react-router-dom";
import { XCircle, ShoppingBag } from "lucide-react";

export default function ShopCheckoutCancelledPage() {
    const slug = (() => {
        try { return sessionStorage.getItem("tw_shop_last_checkout_slug") || ""; }
        catch { return ""; }
    })();
    const shopHref = slug ? `/shop/${slug}` : "/";

    return (
        <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
            <div className="max-w-md w-full bg-white border border-gray-200 rounded-sm p-8 text-center" data-testid="shop-checkout-cancelled-card">
                <XCircle className="w-12 h-12 mx-auto text-gray-400" />
                <h1 className="font-display text-2xl font-black mt-4">Zahlung abgebrochen</h1>
                <p className="text-sm text-gray-600 mt-2">
                    Ihre Bestellung wurde nicht abgeschlossen. Ihr Warenkorb ist noch gefüllt, Sie können den Vorgang jederzeit fortsetzen.
                </p>
                <Link
                    to={shopHref}
                    className="inline-block mt-6 px-5 py-2.5 rounded-sm bg-[#FFCC00] hover:bg-[#FFD633] text-[#111827] font-bold uppercase tracking-wider text-xs"
                    data-testid="shop-checkout-back-to-cart"
                >
                    <ShoppingBag className="w-4 h-4 inline mr-1.5" /> Zurück zum Shop
                </Link>
            </div>
        </div>
    );
}
